













import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

const AbsenceObject = defineComponent({
  props: {
    log: {
      default: () => ({
        reason: '',
        effectiveDate: '',
        leaveUntil: '',
      }),
    },
  },
  setup() {
    function displayDate(date: string) {
      return useFormat.date(date).displayShortThaiDate();
    }

    const list = ['MAINTENANCE'];
    const display = ['ซ่อมแซม'];
    function translateReason(reason: string) {
      const index = list.indexOf(reason);
      if (index > -1) return display[list.indexOf(reason)];
      return '';
    }

    return {
      displayDate,
      translateReason,
    };
  },
});

export default AbsenceObject;
